import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { map, tap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class ProDataManagementService {

  constructor(private http: HttpClient) 
              { }

  myMethod(params: any) {

    let headers = new HttpHeaders();
    headers = headers.append("Content-Type", "application/json");

    return this.http.post<any>(
      environment.apiURL + '/api/v1/admin/.../',
      {
        parameters: params
      },
      {
        headers: headers
      }
    ).pipe(map((res) => {
      console.log(res);
      return res;
    }));

  }
}
